module.exports = __webpack_public_path__ + "static/media/automatetheboring.e6418d0a.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/finals/books/automatetheboring.png
// module id = 303
// module chunks = 0